import React from "react";
import { PeekButton } from "@piiqtechnologies/ui-components";
export const ReportTypeAction = ({ reportType, onSelect }) => {
    return (React.createElement(PeekButton, { variant: reportType.isPrimaryAction ? "contained" : "outlined", color: reportType.isPrimaryAction ? "primary" : "info", size: "large", onClick: onSelect }, reportType.buttonLabel));
};
export default ReportTypeAction;
